import ServicePage from './ServicePage';

const GuidanceParentale = () => <ServicePage serviceKey="parentGuidance" />;

export default GuidanceParentale;
